module.exports = __webpack_public_path__ + "static/media/win_dialog.63f918a1.mp3";